exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flashWrapper-js{position:fixed;width:40vh;height:10vh;bottom:50px;right:50px;z-index:3;background:#4a74c7;display:flex;align-items:center;border-radius:10px;padding:0 20px;justify-content:center;font-size:.9rem;font-weight:700;color:#fff;cursor:pointer}.iconFlash{margin-right:10px}.flash-transit-enter-active,.flash-transit-leave-active{transition:opacity .5s,transform .8s}.flash-transit-enter,.flash-transit-leave-active{opacity:0;transform:translateY(20px)}", ""]);

// exports
